import capitalize from "lodash.capitalize"

export const CHECKBOOK_CONTROLLED_SDIRA = "CHECKBOOK_CONTROLLED_SDIRA"
export const CUSTODIAN_REVIEWED_SDIRA = "CUSTODIAN_REVIEWED_SDIRA"

const SdiraTypeEnum = {
  [CHECKBOOK_CONTROLLED_SDIRA]: CHECKBOOK_CONTROLLED_SDIRA,
  [CUSTODIAN_REVIEWED_SDIRA]: CUSTODIAN_REVIEWED_SDIRA
}

const SdiraTypeEnumKeys = Object.keys(SdiraTypeEnum)

const SdiraTypeEnumOptions = SdiraTypeEnumKeys
  .map(value => ({
    label: capitalize(value),
    value
  }))

export {
  SdiraTypeEnumKeys,
  SdiraTypeEnumOptions
}

export default SdiraTypeEnum
